import {
  HttpError,
  LoyaltyProgram,
  LoyaltyProgramCategory,
  TransactionStatus,
} from '@rd/types';
import { toObject } from '@rd/utils/array.utils';
import {
  LoyaltyProgramActions,
  LoyaltyProgramActionTypes,
} from '../actions/loyalty-program.actions';

export interface LoyaltyProgramState {
  loyaltyPrograms: {
    [key: string]: LoyaltyProgram;
  };
  filter: {
    category: LoyaltyProgramCategory | 'all';
    keyword: string;
  };
  index: {
    status: TransactionStatus;
    error: HttpError | null;
  };
}

const initialState: LoyaltyProgramState = {
  loyaltyPrograms: {},
  filter: {
    category: 'all',
    keyword: '',
  },
  index: {
    status: TransactionStatus.INITIAL,
    error: null,
  },
};

export function loyaltyProgramReducer(
  state: LoyaltyProgramState = initialState,
  action: LoyaltyProgramActions,
): LoyaltyProgramState {
  switch (action.type) {
    case LoyaltyProgramActionTypes.CHANGE_LOYALTY_PROGRAMS_FILTER_CATEGORY:
      return {
        ...state,
        filter: {
          ...state.filter,
          category: action.payload,
        },
      };

    case LoyaltyProgramActionTypes.CHANGE_LOYALTY_PROGRAMS_FILTER_KEYWORD:
      return {
        ...state,
        filter: {
          ...state.filter,
          keyword: action.payload,
        },
      };

    case LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS:
      return {
        ...state,
        index: {
          ...state.index,
          error: null,
          status: TransactionStatus.LOADING,
        },
      };

    case LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS_SUCCESS:
      return {
        ...state,
        loyaltyPrograms: toObject(action.payload, 'id'),
        index: {
          ...state.index,
          status: TransactionStatus.SUCCESS,
        },
      };

    case LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS_FAIL:
      return {
        ...state,
        loyaltyPrograms: {},
        index: {
          status: TransactionStatus.FAIL,
          error: action.payload,
        },
      };
  }

  return state;
}
